import { useCallback } from 'react';
import { useToggle, useLatest } from 'react-use';
import { useRebootActionMutation } from 'apis/cm';

function useRebootDeviceBundle(bundle, { onMutate, ...rest } = {}) {
  const bundleRef = useLatest(bundle);
  const [open, toggleOpen] = useToggle(false);
  const mutation = useRebootActionMutation(rest);
  const { mutate } = mutation;
  const reboot = useCallback(() => {
    toggleOpen(false);
    // @todo simplify status notifications in MaintenancePanelBar
    if (onMutate) {
      onMutate(bundleRef.current);
    }

    const members = bundleRef.current?.members ?? [];

    for (let member of members) {
      mutate(member);
    }
  }, [bundleRef, toggleOpen, onMutate, mutate]);

  return {
    mutation,
    trigger: {
      onClick: toggleOpen
    },
    dialog: {
      open,
      onCancel: toggleOpen,
      onConfirm: reboot
    }
  };
}

export default useRebootDeviceBundle;
